import { list } from "postcss"
import BASE_API from "../../shared/utility/base-api"

export const NOTIFICATION_ENDPOINT = {
  list: `${BASE_API}/notifications/get-notifications`,
  listUnitTypes: `${BASE_API}/properties/unit-types`,
  createNotification: `${BASE_API}/notifications/create-notification`,
  delete: `${BASE_API}/notifications/delete-notification`,
}
